// extracted by mini-css-extract-plugin
module.exports = {"notAvailable":"CoaCombinationTable_notAvailable__3fU8T"};